<section fxLayout="column" class="full-height">
  <header fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" class="sidebar-header">
    <mat-icon class="sidebar-header-icon" svgIcon="info-full-blue"></mat-icon>
    <h3 class="sidebar-header-title" fxFlex>{{ 'TECHNICAL_DATASHEETS.DATASHEET_INFORMATION' | bmsTranslate }}</h3>
    <button mat-icon-button (click)="close()" class="mat-icon-action-button-sm-without-border" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </header>
  <article class="sidebar-content" fxFlex fxLayout="row">
    <app-progress-spinner fxFlex fxLayoutAlign="center center" *ngIf="loading" [text]="'GENERAL.LOADING.LOADING' | bmsTranslate"></app-progress-spinner>
    <div fxLayout="column" fxFlex="100" fxLayoutGap="24px" *ngIf="!loading">
      <div fxLayout="row">
        <div fxLayout="column" fxFlex="100" fxLayoutGap="16px">
          <h4 class="font-weight-semibold">{{ 'GENERAL.PREVIEW' | bmsTranslate }}</h4>
          <app-technical-datasheet-image-preview class="technical-datasheet-image-preview" [technicalDatasheetId]="technicalDatasheetId" [shouldDownloadImage]="true">
          </app-technical-datasheet-image-preview>
        </div>
      </div>
      <div fxLayout="row">
        <div fxLayout="column" fxFlex="100">
          <app-disabled-form-input [label]="'DESIGN_LIBRARY.DESIGN' | bmsTranslate: {count: 1}" [value]="technicalDatasheet?.designName"> </app-disabled-form-input>
          <app-disabled-form-input [label]="'MACHINE_GROUP.GROUP' | bmsTranslate: {count: 1}" [value]="technicalDatasheet?.machineGroupName"> </app-disabled-form-input>
          <app-disabled-form-input [label]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1}" [value]="technicalDatasheet?.machineQualityName"> </app-disabled-form-input>
          <app-disabled-form-input [label]="'TECHNICAL_DATASHEETS.AUTHOR' | bmsTranslate: {count: 1}" [value]="technicalDatasheet?.author"> </app-disabled-form-input>
          <app-disabled-form-input [label]="'TECHNICAL_DATASHEETS.INSTRUCTION_UNIT_SET' | bmsTranslate: {count: 1}" [value]="technicalDatasheet?.instructionUnitSet"> </app-disabled-form-input>
        </div>
      </div>
    </div>
  </article>
  <mat-toolbar fxFlex="initial" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="16px">
    <button mat-icon-button class="mat-icon-action-button-lg-with-border" (click)="onDelete()" [matTooltip]="'GENERAL.ACTIONS.DELETE' | bmsTranslate" matTooltipPosition="above">
      <mat-icon svgIcon="trash"></mat-icon>
    </button>
    <button mat-flat-button (click)="openDatasheetDetails()">
      {{ 'TECHNICAL_DATASHEETS.VIEW_DATASHEET' | bmsTranslate }}
    </button>
  </mat-toolbar>
</section>
